export default __webpack_public_path__ + "static/O0200-c3c1ca8ca0dc62b14a10141f9346a5f6.png";